module.exports = __webpack_public_path__ + "static/media/Modelo_Destaque Atvos_Saúde e Segurança.fb8f0aca.docx";